export function adaptFeature (raw, config) {
  if (!raw?.geometry) return null
  const angelInfo = raw.properties?.angelInfo ?? {}
  const groups = normalizeGroups(angelInfo.group?.value)
  return {
    type: 'Feature',
    id: raw.id,
    geometry: raw.geometry,
    properties: {
      _fill: resolveFill(groups, config),
      groups,
      angelInfo
    }
  }
}

export function normalizeGroups (value) {
  const entries = Array.isArray(value) ? value : (value != null ? [value] : [])
  return entries
    .map(entry => {
      if (entry == null) return null
      if (typeof entry === 'object') return { id: entry.angelId ?? entry.id ?? null, key: entry.key ?? null }
      if (typeof entry === 'number') return { id: entry, key: null }
      return { id: null, key: String(entry) }
    })
    .filter(Boolean)
}

const DEFAULT_GROUP_FILL = { group1: 'rgba(229,57,53,1)', group2: 'rgba(251,140,0,1)' }
const DEFAULT_FILL = 'rgba(67,160,71,1)'

export function resolveFill (entries, config) {
  // A falsy return from the hook means "no company group matched" — fall through to the template defaults
  const configured = config?.fillFor?.(entries)
  if (configured) return configured
  if (entries.some(e => e.key === 'group1')) return DEFAULT_GROUP_FILL.group1
  if (entries.some(e => e.key === 'group2')) return DEFAULT_GROUP_FILL.group2
  return DEFAULT_FILL
}
